import { Accordion, styled } from "@mui/material";


const CustomAccordion = styled(Accordion)(({ theme }) => {
  return {
    boxShadow: 'none',
    border: `none`,
    '.MuiAccordionDetails-root': {},
    '.MuiAccordionSummary-root': {},
  };
});

const FooterAccordion = styled(Accordion)(({ theme }) => {
  return {
    boxShadow: 'none',
    border: `none`,
    marginTop: '0px',
    paddingBottom: '0px',
    '::before': {
      display: 'none',
    },
    '.Mui-expanded': {
      margin: '0px',
      padding: '0px',
      minHeight: '25px',
    },
    '.MuiAccordionDetails-root': {
      height: 'fit-content',
    },
    '.MuiAccordionSummary-root': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: theme.palette.text.secondary,
      cursor: 'pointer',
      'Mui-expanded': {
        margin: '0px',
        padding: '0px',
        minHeight: '25px',        height: '25px',
      }
    },

  };
});

export default CustomAccordion;
export { FooterAccordion };